// extracted by mini-css-extract-plugin
export default {"answer":"waa-z","bestAnswerHeading":"xaa-z","meta":"yaa-z"};